import styled from "styled-components";


const Wrapper = styled.div`
    padding-top: 30px;
`

const WrapperUL = styled.ul`
    display: flex;  
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    padding: 0;
    list-style: none;
    margin: 0;
`
const WrapperLi = styled.li`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    position: relative;
    width: 100%;

    &:before{
        content: '';
        height: ${props => props.active ? '4px' : '2px'};
        width: 100%;
        background-color: ${props => props.active ? '#131f28' : 'grey'};
        position: absolute;
        top: ${props => props.active ? '40px' : '41px'};
        left: -39px;
    }
    &:first-child:before{
        display: none;
    }

    .title {
        color: ${props => props.active ? '#131f28' : 'grey'};
        font-weight: ${props => props.active ? '600' : '500'};
    }

    .circle {
        height: 30px;
        width: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background: ${props => props.active ? '#131f28' : 'grey'};
        z-index: 1;
    }

    .checkmark {
        height: 13px;
        width: 8px;
        border-right: 3px solid white;
        border-bottom: 3px solid white;
        transform: rotate(45deg);
    }

    .dot {
        height: 8px;
        width: 8px;
        background: white;
        border-radius: 50%;
    }

    @media only screen and (max-width: 899px) {
        &:before{
            left: -75px;
        }
    }
    @media only screen and (max-width: 600px) {
        &:before{
            left: -70px;
        }
    }
    @media only screen and (max-width: 547px) {
        &:before{
            left: -65px;
        }
    }
    @media only screen and (max-width: 499px) {
        &:before{
            left: -60px;
        }
    }
    @media only screen and (max-width: 450px) {
        &:before{
            left: -55px;
        }
    }
    @media only screen and (max-width: 399px) {
        &:before{
            left: -39px;
        }
    }
`


export { Wrapper, WrapperUL, WrapperLi }